import { GetPromotionTypesResponse } from "../../worker/api/get_promotion_types";
import { AnyAction } from "redux";

export const promotionsActionTypes = {
  ACTION_SET_PROMOTIONS: "ACTION_SET_PROMOTIONS",
  ACTION_CLEAR_PROMOTIONS: "ACTION_CLEAR_PROMOTIONS",
  ACTION_SET_SELECTED_PROMOTION: "ACTION_SET_SELECTED_PROMOTION",
  ACTION_CLEAR_SELECTED_PROMOTION: "ACTION_CLEAR_SELECTED_PROMOTION",
};

export interface PromotionsInitialStateProps {
  promotions: GetPromotionTypesResponse[];
  selectedPromotion: GetPromotionTypesResponse | null;
}

const promotionsInitialState: PromotionsInitialStateProps = {
  promotions: [],
  selectedPromotion: null,
};

export default function reducer(
  state = promotionsInitialState,
  action: AnyAction
): PromotionsInitialStateProps {
  switch (action.type) {
    case promotionsActionTypes.ACTION_SET_PROMOTIONS:
      return {
        ...state,
        promotions: action.payload,
      };
    case promotionsActionTypes.ACTION_CLEAR_PROMOTIONS:
      return {
        ...state,
        promotions: [],
      };
    case promotionsActionTypes.ACTION_SET_SELECTED_PROMOTION:
      return {
        ...state,
        selectedPromotion: action.payload,
      };
    case promotionsActionTypes.ACTION_CLEAR_SELECTED_PROMOTION:
      return {
        ...state,
        selectedPromotion: null,
      };
    default:
      return state;
  }
}
